<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      <p>Copyright ©2018-2026 InstaSave not affiliated, associated with Instagram. We don't host any content.</p>
    </div>
    <div class="footer-links">
      <a href="/privacy" class="footer-link">Privacy Policy</a>
      <a href="/terms" class="footer-link">Terms of Service</a>
      <a href="/dmca" class="footer-link">DMCA</a>
      <a href="/contact" class="footer-link">Contact</a>
    </div>

  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer {
  // background-color: #282828;
  background-color: transparent;
  border-top: 1px solid #e2e8f0;
  color: #121212;
  padding: 20px 0 48px;
}

@media (max-width: 768px) {
  .footer {
    padding: 20px 0 50px;
  }
}

.footer-container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.footer-links {
  display: flex;
  gap: 15px;
}

.footer-link {
  color: #1b3d76;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #2880ba;
}

.footer-note {
  font-size: 15px;

  p {
    margin: 0;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
  }

  .footer-links {
    justify-content: center;
    margin-bottom: 10px;
  }

  .footer-note {
    font-size: 10px;
  }
}
</style>
